module.exports = __webpack_public_path__ + "static/media/arrow-25.89b04cb0.svg";